import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material';

export const CashbackIndicator = (props: any) => {
  const [yPos, setYPos] = useState(80);
  const [label, setLabel] = useState(undefined);
  const theme = useTheme();
  const radius = 26;
  const diameter = radius * 2;
  const lineLength = 26;
  const yOffset = -55;
  const xAxisHeight = 50;

  if (label !== props.label) {
    setLabel(props.label);
    setYPos(80);
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (yPos <= props.cy) {
        setYPos(yPos + 2);
      }
    }, 3);
    return () => clearTimeout(timer);
  });

  return (
    <svg width={diameter} height={diameter} style={{ overflow: 'visible' }}>
      <polygon
        points={`${props.cx - lineLength},${yPos + yOffset} ${props.cx + lineLength},${
          yPos + yOffset
        } ${props.cx},${yPos + yOffset + 1.5 * lineLength}`}
        fill={theme.palette.text.primary}
        fillOpacity="70%"
        strokeWidth="0"
      />
      <circle
        cx={props.cx}
        cy={yPos + yOffset}
        r={radius}
        fill={theme.palette.text.primary}
        strokeWidth="0"
      />
      <text
        x={props.cx}
        y={yPos + yOffset}
        fontSize={14}
        fontWeight="bold"
        alignmentBaseline="central"
        textAnchor="middle"
        fill={theme.palette.primary.contrastText}
      >
        {props.label}
      </text>

      <line
        x1={props.cx}
        y1={props.cy + 10}
        x2={props.cx}
        y2={props.height - xAxisHeight + 10}
        style={{ stroke: theme.palette.primary.main, strokeWidth: 2 }}
        strokeDasharray="5 5"
      />
    </svg>
  );
};
